import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { BaseChatMessageArgs } from '../../chat/args/BaseChatMessageArgs'
import type { ChatMessage } from '../../chat/Chat'

/**
 * We just need to extend AddChatMessageArgs to include the information related to the orderId
 */
@InputType()
export class AddPurchaseOrderChatMessageArgs extends BaseChatMessageArgs {
  @Field(() => ID)
  purchaseOrderId: string
}

export interface IAddPurchaseOrderChatMessage extends IAction<ChatMessage, AddPurchaseOrderChatMessageArgs> {}
